import { Helmet } from 'react-helmet-async';

/**
 * Google Analytics component that adds the gtag.js tracking code to the page
 * @returns {JSX.Element} A Helmet component containing Google Analytics scripts
 */
const GoogleAnalytics = () => {
  return (
    <Helmet>
      {/* Google tag (gtag.js) */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-25KBHPF62S"></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-25KBHPF62S');
          
          // Test function for verifying Google Analytics is working
          window.testGA = function() {
            if (typeof gtag !== 'undefined') {
              gtag('event', 'test_event', {
                event_category: 'testing',
                event_label: 'ga_implementation_test'
              });
              console.log('✅ Google Analytics test event sent!');
              return true;
            } else {
              console.log('❌ Google Analytics not loaded');
              return false;
            }
          };
        `}
      </script>
    </Helmet>
  );
};

export default GoogleAnalytics;